import { useCallback, useEffect } from 'react';
import { logout } from 'v2/resources/helpers/logout';

const useLogout = () => {
  const handleLogout = useCallback(async () => {
    await logout();
  }, []);

  useEffect(() => {
    handleLogout();
  }, [handleLogout]);
  return {};
};
export default useLogout;
